import { render, staticRenderFns } from "./DetailsSidebar.vue?vue&type=template&id=43c8fcbe&scoped=true"
import script from "./DetailsSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailsSidebar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DetailsSidebar.vue?vue&type=style&index=0&id=43c8fcbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c8fcbe",
  null
  
)

export default component.exports